// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


// import React from "react";
// import { Outlet, Link, useNavigate } from "react-router-dom";

// export default function App() {
//   const navigate = useNavigate();

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     navigate("/login");
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <header style={{ display: "flex", gap: 10, marginBottom: 20 }}>
//         <Link to="/">Dashboard</Link>
//         <Link to="/leads">Leads</Link>
//         <Link to="/projects">Projects</Link>
//         <Link to="/boq">BOQ</Link>
//         <Link to="/vendors">Vendors</Link>
//         <Link to="/inventory">Inventory</Link>
//         <Link to="/pos">POs</Link>
//         <Link to="/grn">GRN</Link>
//         <Link to="/invoices">Invoices</Link>
//         <Link to="/service">Service</Link>

//         <button onClick={logout} style={{ marginLeft: "auto" }}>
//           Logout
//         </button>
//       </header>

//       <Outlet />
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import { ThemeProvider, CssBaseline } from "@mui/material";
// import MainLayout from "./layout/MainLayout";
// import { getTheme } from "./theme";

// export default function App() {
//   const [mode, setMode] = useState("light");

//   return (
//     <ThemeProvider theme={getTheme(mode)}>
//       <CssBaseline />
//       <MainLayout
//         mode={mode}
//         onToggleTheme={() => setMode(mode === "light" ? "dark" : "light")}
//       >
//         <Outlet />
//       </MainLayout>
//     </ThemeProvider>
//   );
// }


// // src/App.js
// import React, { useState, useEffect } from "react";
// import { Outlet } from "react-router-dom";
// import MainLayout from "./layout/MainLayout";

// export default function App() {
//   const [mode, setMode] = useState(() => {
//     // Initialize theme from localStorage or default to light
//     return localStorage.getItem("theme") || "light";
//   });

//   useEffect(() => {
//     // Update document class for dark mode
//     if (mode === "dark") {
//       document.documentElement.classList.add("dark");
//     } else {
//       document.documentElement.classList.remove("dark");
//     }
    
//     // Save to localStorage
//     localStorage.setItem("theme", mode);
//   }, [mode]);

//   const toggleTheme = () => {
//     setMode(mode === "light" ? "dark" : "light");
//   };

//   return (
//     <MainLayout mode={mode} onToggleTheme={toggleTheme}>
//       <Outlet />
//     </MainLayout>
//   );
// }

// // src/App.jsx
// import React, { useState, useEffect } from "react";
// import { Outlet, useNavigate } from "react-router-dom";
// import MainLayout from "./layout/MainLayout";
// import api from "./utils/api"; // Make sure this path is correct

// export default function App() {
//   const navigate = useNavigate();

//   const [mode, setMode] = useState(() => {
//     return localStorage.getItem("theme") || "light";
//   });

//   // Theme handling
//   useEffect(() => {
//     if (mode === "dark") {
//       document.documentElement.classList.add("dark");
//     } else {
//       document.documentElement.classList.remove("dark");
//     }
//     localStorage.setItem("theme", mode);
//   }, [mode]);

//   const toggleTheme = () => {
//     setMode(mode === "light" ? "dark" : "light");
//   };
// useEffect(() => {
//   const token = localStorage.getItem("token");
//   if (!token) {
//     navigate("/login");
//     return;
//   }

//   const fetchCurrentUser = async () => {
//     try {
//       const res = await api.get("/auth/me");
//       localStorage.setItem("user", JSON.stringify(res.data.user));
//     } catch (err) {
//       if (err.response?.status === 401) {
//         localStorage.removeItem("token");
//         localStorage.removeItem("user");
//         navigate("/login");
//       }
//     }
//   };

//   fetchCurrentUser();
// }, [navigate]);
//   // === NEW: Refresh user data on app mount ===
//   // useEffect(() => {
//   //   const token = localStorage.getItem("token");

//   //   if (!token) {
//   //     // No token → redirect to login
//   //     navigate("/login");
//   //     return;
//   //   }

//   //   const fetchCurrentUser = async () => {
//   //     try {
//   //       const res = await api.get("/auth/me"); // Calls backend /api/auth/me
//   //       localStorage.setItem("user", JSON.stringify(res.data.user));
//   //       // Optional: if your backend returns a new token, update it
//   //       // if (res.data.token) localStorage.setItem("token", res.data.token);
//   //     } catch (err) {
//   //       console.error("Failed to refresh user data:", err);

//   //       // If token is invalid/expired → force logout
//   //       if (err.response?.status === 401 || err.response?.status === 403) {
//   //         localStorage.removeItem("token");
//   //         localStorage.removeItem("user");
//   //         navigate("/login");
//   //       }
//   //     }
//   //   };

//   //   fetchCurrentUser();
//   // }, [navigate]);
//   // ==========================================

//   return (
//     <MainLayout mode={mode} onToggleTheme={toggleTheme}>
//       <Outlet />
//     </MainLayout>
//   );
// }

import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import api from "./utils/api";

export default function App() {
  const navigate = useNavigate();

  const [mode, setMode] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });

  // Theme handling
  useEffect(() => {
    if (mode === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode(mode === "light" ? "dark" : "light");
  };

  // Refresh user on mount if token exists
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchCurrentUser = async () => {
      try {
        const res = await api.get("/auth/me");
        let userData = res.data.user;

        // FIX: Clean corrupted permissions
        if (typeof userData.permissions === "string") {
          try {
            userData.permissions = JSON.parse(userData.permissions);
          } catch (e) {
            console.error("Corrupted permissions JSON, resetting", e);
            userData.permissions = {};
          }
        }

        localStorage.setItem("user", JSON.stringify(userData));
      } catch (err) {
        console.error("Failed to fetch current user", err);
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/login");
        }
      }
    };

    fetchCurrentUser();
  }, [navigate]);

  return (
    <MainLayout mode={mode} onToggleTheme={toggleTheme}>
      <Outlet />
    </MainLayout>
  );
}